const UNSAFE_CHARS = {
  '&': 'interpreted as URL parameter separator',
  '%': 'interpreted as URL encoding',
  '?': 'interpreted as query string start',
  '#': 'interpreted as URL fragment',
  '+': 'interpreted as space in URL encoding',
  '=': 'interpreted as key=value separator in URL',
};

// eslint-disable-next-line no-control-regex
const HAS_NON_ASCII = /[^\x00-\x7F]/;

export const sanitizeFileName = (filename) => filename.replace(/\s+/g, '_');

export const validateFileName = (filename) => {
  if (!filename) return 'Filename is required.';

  const issues = [];

  const foundUnsafe = Object.keys(UNSAFE_CHARS).filter((char) => filename.includes(char));
  if (foundUnsafe.length > 0) {
    const charList = foundUnsafe.map((char) => `"${char}" (${UNSAFE_CHARS[char]})`).join(', ');
    issues.push(`contains unsafe characters: ${charList}`);
  }

  if (HAS_NON_ASCII.test(filename)) {
    issues.push('contains non-ASCII characters (e.g. Cyrillic, emoji)');
  }

  if (issues.length === 0) return null;

  return (
    `File name ${issues.join('; ')}. ` +
    'Please rename the file using only letters, numbers, hyphens (-), underscores (_), dots (.), and tildes (~).'
  );
};
